/**entities公用方法 */
export function publicFun(api,params){
  return new Promise((resolve, reject) => {
    api(params)
        .then((res) => {
            resolve(res.data);
            return;
        })
        .catch((err) => {
            reject(err);
        });
  });
}




// WEBPACK FOOTER //
// ./src/logics/entities/common.js